var _circle, _circle2, _circle3, _path, _path2, _path3, _circle4, _path4, _path5, _path6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderplacedbg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 198,
    viewBox: "0 0 270 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.3153,
    cy: 77.4515,
    r: 5.25031,
    fill: "#5070DE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.414,
    cy: 20.3542,
    r: 11.1569,
    fill: "#5070DE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.827,
    cy: 124.704,
    r: 10.5006,
    fill: "#FEB926"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.886 6.57227L201.619 14.3405L209.387 17.0729L201.619 19.8053L198.886 27.5735L196.154 19.8053L188.386 17.0729L196.154 14.3405L198.886 6.57227Z",
    fill: "#FF7E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9847 103.088C36.9847 103.088 34.8237 111.812 24.5887 112.187C17.7654 112.438 16.1602 105.366 8.18946 110.153C4.63973 112.285 2 118.762 2 118.762",
    stroke: "#FF7E00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7215 153.582L44.5125 163.573L54.5036 167.364L44.5125 171.155L40.7215 181.146L36.9306 171.155L26.9395 167.364L36.9306 163.573L40.7215 153.582Z",
    fill: "#FEB926"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.944,
    cy: 3.94742,
    r: 2.62516,
    fill: "#FF7E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6785 4.94802C50.9689 16.1653 77.036 27.3457 77.6168 18.1683C78.5372 3.62545 43.3818 14.9644 91.3438 34.0216",
    stroke: "#FEB926",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.202 175.645C248.717 174.72 262.924 176.278 267.626 189.907",
    stroke: "#169560",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.743 49.0575C235.743 49.0575 245.27 53.9045 249.263 49.5604C252.906 45.5979 248.694 39.4136 253.101 36.3234C256.686 33.8088 264.282 35.4651 264.282 35.4651",
    stroke: "#FEB926",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 231.701,
    y: 97.1406,
    width: 9.18804,
    height: 9.18804,
    rx: 2,
    fill: "#FEB926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderplacedbg);
export default __webpack_public_path__ + "static/media/orderplacedbg.c843007e12b60d0629f6a3af1f1e06fb.svg";
export { ForwardRef as ReactComponent };